import React from 'react';
import { Button, Layout } from 'antd';
import { userHelpers } from 'helpers';
import { t } from 'helpers/i18n';
import AppHeaderWithLogoOnly from '../AppHeaderWithLogoOnly';
import './NoOrganization.scss';

const NoOrganization: React.FC = () => {
  const logout = () => {
    userHelpers.logout();
  };

  return (
    <Layout className="app-layout">
      <AppHeaderWithLogoOnly />
      <div className="app-header-placeholder-v2" />
      <div className="no-organization-container">
        <h1 className="no-organization-title">{t('no_organization_title')}</h1>
        <p className="no-organization-description">
          {t('no_organization_description')}
        </p>
        <Button
          className="no-organization-logout-button"
          type="primary"
          ghost={true}
          onClick={logout}
        >
          {t('Logout')}
        </Button>
      </div>
    </Layout>
  );
};

export default NoOrganization;
